import { render } from "./Legend.vue?vue&type=template&id=3e4992b8&scoped=true&ts=true"
import script from "./Legend.vue?vue&type=script&lang=ts"
export * from "./Legend.vue?vue&type=script&lang=ts"

import "./Legend.vue?vue&type=style&index=0&id=3e4992b8&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4992b8"]])

export default __exports__